module.exports = __webpack_public_path__ + "img/topAnalysis.6defbf7f.svg";